import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Api_Url } from '../../../../utils/ApiUrl';
import Loader from '../../../../hooks/loader';
import { formatDecimal } from '../../../../utils/formatDecimal';
import ReactPaginate from 'react-paginate';
import { useCreditConsumed } from '../../../../hooks/Refund/useCreditConsumed';
import { Pagination } from './Pagination';

function CreditConsumed({ startDate, endDate  }) {
    const {
        consumedTransactions,
        loading,
        error,
        page,
        pageCount,
        totalItems,
        itemsPerPage,
        handlePageChange,
        startItem,
        endItem
    } = useCreditConsumed(startDate, endDate);
    return (
        <>
            {loading && <Loader />}
            <div className="table-responsive">
                <table className="table">
                    <thead>
                        <tr>
                            <th>
                                <div className="parent-tag">
                                    Date{' '}
                                    <div className="filter-btn" style={{ cursor: 'pointer' }}>
                                        <svg
                                            width="9"
                                            height="6"
                                            viewBox="0 0 9 6"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                                                fill="#77868B"
                                            />
                                        </svg>
                                        <svg
                                            width="9"
                                            height="6"
                                            viewBox="0 0 9 6"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                                                fill="#77868B"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </th>
                            <th>Country</th>
                            {/* <th>Hash</th> */}
                            <th>Wallet Address</th>
                            <th>Project</th>
                            <th>Credits Used</th>
                            <th>Tokens Purchased</th>
                        </tr>
                    </thead>
                    <tbody>
                        {consumedTransactions?.map((transaction) => (
                            <tr key={transaction._id}>
                                <td>
                                    <div className="twice-text">
                                        <h6>{new Date(transaction?.createdAt).toLocaleDateString('en-IL', { timeZone: 'Asia/Jerusalem' })}</h6>
                                        <p>{new Date(transaction?.createdAt).toLocaleTimeString('en-IL', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Jerusalem' })}</p>
                                    </div>
                                </td>
                                <td className='text-capitalize'>{transaction.country}</td>
                                {/* <td>
                                    {transaction.transactionHash ? (
                                        <a
                                            href={`https://etherscan.io/tx/${transaction.transactionHash}`} // Assuming it's an Ethereum transaction
                                            className="codepara"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {transaction.transactionHash.slice(0, 7)}...{transaction.transactionHash.slice(-3)}
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="15"
                                                height="15"
                                                viewBox="0 0 15 15"
                                                fill="none"
                                                cursor="pointer"
                                            >
                                                <path
                                                    d="M5.97629 3.41683H4.92629C4.2729 3.41683 3.94595 3.41683 3.69639 3.54399C3.47687 3.65584 3.29852 3.83419 3.18667 4.05371C3.05951 4.30327 3.05951 4.63022 3.05951 5.28361V9.71694C3.05951 10.3703 3.05951 10.6969 3.18667 10.9464C3.29852 11.166 3.47687 11.3446 3.69639 11.4565C3.94571 11.5835 4.27226 11.5835 4.92437 11.5835H9.36131C10.0134 11.5835 10.3395 11.5835 10.5888 11.4565C10.8083 11.3446 10.9873 11.1658 11.0991 10.9463C11.2262 10.6969 11.2262 10.3707 11.2262 9.71863V8.66683M11.8095 5.75016V2.8335M11.8095 2.8335H8.89284M11.8095 2.8335L7.72618 6.91683"
                                                    stroke="#77868B"
                                                    strokeWidth="1.2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </a>
                                    ) : (
                                        <p className="codepara">N/A</p>
                                    )}
                                </td> */}
                                <td>
                                    <p className="codepara">
                                        {transaction.by.slice(0, 7)}...{transaction.by.slice(-3)}
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="15"
                                            height="15"
                                            viewBox="0 0 15 15"
                                            fill="none"
                                            cursor="pointer"
                                        >
                                            <path
                                                d="M10.1281 7.99972L10.1545 10.4496C10.1765 12.4911 9.36866 13.3165 7.32711 13.3385L4.87726 13.3649C2.83571 13.3869 2.0103 12.5791 1.98831 10.5375L1.96193 8.08766C1.93995 6.04611 2.74777 5.2207 4.78932 5.19871L7.23918 5.17233C9.28073 5.15035 10.1061 5.95817 10.1281 7.99972Z"
                                                stroke="#77868B"
                                                strokeWidth="1.2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M13.5902 4.46213L13.6166 6.91198C13.6386 8.95353 12.8308 9.77895 10.7892 9.80093L10.1476 9.80784L10.1281 7.99961C10.1061 5.95806 9.28071 5.15024 7.23917 5.17222L5.43094 5.19169L5.42403 4.55006C5.40204 2.50851 6.20987 1.6831 8.25142 1.66112L10.7013 1.63474C12.7428 1.61275 13.5682 2.42058 13.5902 4.46213Z"
                                                stroke="#77868B"
                                                strokeWidth="1.2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </p>
                                </td>
                                <td>
                                    <div className="maintoken">
                                        {/* You might need a different icon based on the project */}
                                        {transaction.privateSale && (
                                            <div className="tokenimg">
                                                <img
                                                    src={`/assets/${transaction?.privateSale.toLowerCase()}.svg`}
                                                    alt="innerimg"
                                                    className="innerimg"
                                                />
                                            </div>
                                        )}
                                        <p className="tokenpara">{transaction.privateSale}</p>
                                    </div>
                                </td>
                                <td>{formatDecimal(transaction.creditConsumed) }</td>
                                <td>{formatDecimal(transaction.tokenPurchased)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="footer-content">
                <Pagination startItem={startItem} endItem={endItem} totalItems={totalItems} pageCount={pageCount} handlePageChange={handlePageChange} page={page} />
            </div> 
        </>
    );
}

export default CreditConsumed;